export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/feature-coupon.f62698cb-8a2c8e.svg";